import "./MesCours.css";

import React, { useEffect, useState } from "react";

import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import ListCourses from "../../Component/ListCourses/ListCourses";
import { AJOUT_COURS_NAVIGATION } from "../../Routes/NAVIGATION_PATH";
import { Link } from "react-router-dom";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db, getDocument } from "../../Firebase";
import { Date } from "../../Services";
import CardsCours from "../../Component/CardsCours/CardsCours";
import { GiBookmarklet, GiSpellBook, GiWhiteBook } from "react-icons/gi";
import { FaUserGraduate } from "react-icons/fa";
import PaginationContainer from "../../Component/PaginationContainer/PaginationContainer";



function MesCours() {
  
  const [students, setStudents] = useState([])
  const [userCurrent, setUserCurrent] = useState({});
  const [myCours, setMyCours] = useState([]);
  const [myStudents, setMyStudents] = useState([]);
  const [currentUser, setCurrentUser ] = useState([]);
  const reftabCours = query(collection(db, "cours"));
  const reftabUsers = query(collection(db, "users"));
  const currentUserId = sessionStorage.getItem("user_id");


  const getStudents = () => {
    const data = []
    onSnapshot(reftabUsers, (item) => {
      item.forEach((donne) => {
        data.push({ ...donne.data(), id: donne.id })
      })
      setStudents(data);
    })
  }
  const etudAdmin= myStudents.filter((i)=> i.admin_id === currentUser.admin_id && i.user_type=== "etudiant")
  const mes_etudiants = etudAdmin.filter((item) => item.domaine === userCurrent.domaine.toLowerCase() )



  const getUsers = () => {
    onSnapshot(reftabCours, (item) => {
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      }); 
      setMyCours(data);
    });

    onSnapshot(reftabUsers, (item) => {
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });
      setMyStudents(data);
    });
  };
  
  const coursAdmin =myCours.filter((i)=> i.admin_id === currentUser.admin_id)
  const coursesByProf = myCours.filter((item) => item.created_by === currentUserId );
  const coursRejeteer = coursesByProf.filter((item)=> item?.isArchived === true)
  const coursEnAttente = coursesByProf.filter((item)=> item?.isArchived ===false && item?.isApproved ===false)
  


  useEffect(() => {
    getUsers();
    getDocument('users',currentUserId , setCurrentUser)
  }, []);

  useEffect(() => {
    getStudents();
    getDocument("users", currentUserId, setUserCurrent)
  }, [currentUserId]);
  
 
  const cardData = [
    { titre: "Etudiants", text: 'Etudiants', icon: <FaUserGraduate />, total: etudAdmin.length, couleur: "red", nombre:mes_etudiants.length },
    { titre: "cours approuvés", text: 'Cours', icon: <GiBookmarklet />, total: coursAdmin.length, couleur: 'blue', nombre: coursesByProf.length },
    { titre: "cours rejetés", text: 'Cours en attente', icon: <GiSpellBook />, total: coursEnAttente.length, couleur: "#754ffe", nombre:coursRejeteer.length
   },
    // { titre: "Valider", text: 'Cours', icon: <GiWhiteBook />, total: 12, couleur: 'green', nombre: 14 },
  ]
  const [searchTerm, setSearchTerm] = useState("");

     const filteredData = coursesByProf.filter((elt) =>
     elt?.titre_cours?.toLowerCase().includes(searchTerm?.toLowerCase() ) ||
     elt?.description?.toLowerCase().includes(searchTerm?.toLowerCase() )  ||
     elt?.infoUser?.toLowerCase().includes(searchTerm?.toLowerCase() )
    );
  
     const handelTermChange = (e) => {
      setSearchTerm(e.target.value.toLowerCase());
     };
  
     const myDatas = searchTerm === "" ? coursesByProf : filteredData ;
  return (
    <div className="mes-cours container py-4">
      <h3 className="pt-2 ">DASHBOARD
        <hr />
      </h3>
      <div className="container-fluid">
        <Row className="py-4">
          {
            cardData.map(({ titre, text, icon, nombre, couleur, total }, index) =>
              <Col  md={4} key={index}>
                <CardsCours
                  cours={titre}
                  icon={icon}
                  nombre={nombre}
                  texte={text}
                  couleur={couleur}
                  total={total}
                  key = {index}
                  className='pe-2'
                />
              </Col>
            )
          }
        </Row>
      </div>

      <div className="d-flex mb-2 justify-content-end ajouRecher">
        <input
          type="text"
          onChange={handelTermChange}
          value={searchTerm}
          className="form-control w-25"
          id="exampleInputEmail1"
          placeholder="Recherche cours"
          aria-describedby="emailHelp"
        />
        <div className="cont-btn-aj ps-2 ">
          <Link to={AJOUT_COURS_NAVIGATION}>
            <Button variant="primary">Ajouter un cours</Button>
          </Link>
        </div>
      </div>
      <Table  bordered  responsive>
        <thead>
          <tr className="py-5">
            <th>COURS</th>
            <th>STATUT</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
          <PaginationContainer data={myDatas} ItemComponent = {ListCourses}  />
        </tbody>
      </Table>
    </div>
  );
}

export default MesCours;
